module.exports = __webpack_public_path__ + "img/bg_login.6b75eb63.png";